import { render, staticRenderFns } from "./get-create-username-link.vue?vue&type=template&id=606893ae&scoped=true&"
import script from "./get-create-username-link.vue?vue&type=script&lang=js&"
export * from "./get-create-username-link.vue?vue&type=script&lang=js&"
import style0 from "@/assets/auth-screen.scss?vue&type=style&index=0&id=606893ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606893ae",
  null
  
)

component.options.__file = "get-create-username-link.vue"
export default component.exports